import React, { useState } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
export function AdminLoginPage({
  navigateTo
}: {
  navigateTo: (page: string) => void;
}) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    navigateTo('adminDashboard');
  };
  return <div className="min-h-screen bg-[#F5F7F9] flex flex-col relative overflow-hidden font-sans" data-id="element-67">
      {/* Top Bar Logos */}
      <div className="absolute top-4 left-4 flex items-center gap-4 z-20" data-id="element-68">
        <button onClick={() => navigateTo('home')} className="flex items-center justify-center w-10 h-10 bg-white rounded-full shadow hover:bg-gray-50 transition-colors text-[#006A4E]" title="Back to Home" data-id="element-69">
          <ArrowLeftIcon className="w-5 h-5" data-id="element-70" />
        </button>
        <img src="https://cdn.magicpatterns.com/uploads/9zTMD1Cxv4NB3L18v8BPEZ/dlrmslogo.png" alt="Gov Logo" className="h-12 object-contain" data-id="element-71" />
        <div className="w-px h-10 bg-gray-300" data-id="element-72"></div>
        <img src="https://cdn.magicpatterns.com/uploads/64WUNBj7L71rcFyvALcTYv/lmap_logo.png" alt="LMAP Logo" className="h-12 object-contain" data-id="element-73" />
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center pt-20 pb-32 px-4 z-10" data-id="element-74">
        {/* Notice Banner */}
        <div className="bg-[#DCE7D8] text-[#333333] px-8 py-4 rounded-lg max-w-2xl w-full text-center mb-8 shadow-sm border border-[#C5D6C0]" data-id="element-75">
          <p className="font-bold text-[15px] leading-relaxed" data-id="element-76">
            অফিস ব্যবহারকারীগণ কর্তৃক লগইন করতে কোন সমস্যা পরিলক্ষিত হলে বা বদলি
            জনিত কারণে সহায়তার জন্য নিম্নের নাম্বারে যোগাযোগ করুনঃ
          </p>
          <p className="font-bold text-[16px] mt-1 text-[#006A4E]" data-id="element-77">
            ০১৮৯৬০৪৭১১৭, ০১৮৯৬০৪৭১১১
          </p>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-xl shadow-xl border border-gray-200 w-full max-w-md p-8 relative" data-id="element-78">
          {/* Card Logos */}
          <div className="flex justify-center items-center gap-4 mb-6" data-id="element-79">
            <img src="https://cdn.magicpatterns.com/uploads/9zTMD1Cxv4NB3L18v8BPEZ/dlrmslogo.png" alt="Gov Logo" className="h-14 object-contain" data-id="element-80" />
            <div className="w-px h-12 bg-gray-200" data-id="element-81"></div>
            <img src="https://cdn.magicpatterns.com/uploads/64WUNBj7L71rcFyvALcTYv/lmap_logo.png" alt="LMAP Logo" className="h-14 object-contain" data-id="element-82" />
          </div>

          <h2 className="text-xl font-bold text-center text-gray-800 mb-6" data-id="element-83">
            লগইন করুন
          </h2>

          <form onSubmit={handleLogin} className="space-y-5" data-id="element-84">
            <div data-id="element-85">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-86">
                ইউজারনেম
              </label>
              <input type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder="ইউজারনেম" className="w-full px-4 py-2.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" required data-id="element-87" />
            </div>

            <div data-id="element-88">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-89">
                পাসওয়ার্ড
              </label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="পাসওয়ার্ড" className="w-full px-4 py-2.5 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#006A4E] focus:border-transparent text-sm" required data-id="element-90" />
            </div>

            <div className="flex flex-col items-end space-y-1" data-id="element-91">
              <a href="#" className="text-sm font-bold text-[#B71C1C] hover:underline" data-id="element-92">
                পাসওয়ার্ড ভুলে গেছেন?
              </a>
              <a href="#" className="text-sm font-bold text-[#B71C1C] hover:underline" data-id="element-93">
                রেজিস্ট্রেশন করুন
              </a>
              <a href="#" className="text-sm font-bold text-[#B71C1C] hover:underline" data-id="element-94">
                সাপোর্ট টিকেট
              </a>
            </div>

            <button type="submit" className="w-full bg-[#006A4E] text-white font-bold py-3 rounded hover:bg-[#004D3A] transition-colors mt-2" data-id="element-95">
              লগইন করুন
            </button>

            <div className="relative flex items-center py-2" data-id="element-96">
              <div className="flex-grow border-t border-gray-300" data-id="element-97"></div>
              <span className="flex-shrink-0 mx-4 text-gray-500 text-sm font-medium" data-id="element-98">
                or
              </span>
              <div className="flex-grow border-t border-gray-300" data-id="element-99"></div>
            </div>

            <button type="button" className="w-full bg-[#006A4E] text-white font-bold py-3 rounded hover:bg-[#004D3A] transition-colors flex flex-col items-center justify-center leading-tight" data-id="element-100">
              <span data-id="element-101">GEMS এর মাধ্যমে</span>
              <span data-id="element-102">লগইন</span>
            </button>
          </form>
        </div>
      </div>

      {/* City Skyline Background */}
      <div className="absolute bottom-12 left-0 right-0 h-64 z-0 opacity-90 pointer-events-none bg-repeat-x bg-bottom" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/6yxN9DvjBUJA5vs5aodpdf/LSG-Login.png")',
      backgroundPosition: 'center bottom',
      backgroundSize: 'cover',
      maskImage: 'linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 60%, rgba(0,0,0,0) 100%)',
      WebkitMaskImage: 'linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 60%, rgba(0,0,0,0) 100%)'
    }} data-id="element-103"></div>

      {/* Footer */}
      <footer className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-200 py-3 px-6 flex flex-col sm:flex-row justify-between items-center z-20 text-sm" data-id="element-104">
        <div className="font-bold text-gray-800 mb-2 sm:mb-0" data-id="element-105">
          ভূমি ব্যবস্থাপনা অটোমেশন প্রকল্প, ভূমি মন্ত্রণালয়
        </div>
        <div className="flex items-center gap-2" data-id="element-106">
          <span className="font-bold text-gray-800" data-id="element-107">কারিগরি সহায়তায়</span>
          <img src="https://cdn.magicpatterns.com/uploads/vYSGi6LSWZxGWV26FhjYcC/softbd.png" alt="SoftBD Logo" className="h-6 object-contain" data-id="element-108" />
        </div>
      </footer>
    </div>;
}